export default __webpack_public_path__ + "static/media/transition-2.45370607.mp3";